import { useContext } from 'react'

import { useStore } from 'zustand'

import { ComposerContext } from '../ComposerContext'
import type { ComposerState, ComposerActions } from '../composerStore'

/**
 * A hook to access the composer zustand store.
 * To ensure store interactions remain abstracted from components,
 * this hook is not meant for direct use.
 * Default to creating specific hooks for each piece of state or action.
 * @internal Do not use this hook directly
 */
export function useComposerStore<T>(
  selector: (state: ComposerState & ComposerActions) => T,
): T {
  const store = useContext(ComposerContext)
  if (!store)
    throw new Error('ComposerContext can only be used within ComposerProvider')
  return useStore(store, selector)
}
